import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../../catalyst/button'
import { Divider } from '../../catalyst/divider'
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '../../catalyst/dropdown'
import { Heading } from '../../catalyst/heading'
import { Input, InputGroup } from '../../catalyst/input'
import { Select } from '../../catalyst/select'

import { EllipsisVerticalIcon, MagnifyingGlassIcon } from '@heroicons/react/16/solid'
import { format, parseISO } from 'date-fns'
import { ErrorMessage, Field } from '../../catalyst/fieldset'
import { Text } from '../../catalyst/text'
import ConfirmationModel from '../../components/ConfirmationModel'
import LoadingMain from '../../components/LoadingMain'
import config from '../../config'
import { getIconForTransfer, getSyncStatusBadge } from '../../utils'
import EditSyncModel from './editSyncModel'




export default function SyncMain() {

  const [syncs, setSyncs] = useState([])

  const [orderedSyncs, setOrderedSyncs] = useState([])
  const [filterName, setFilterName] = useState("")
  const [filterSort, setFilterSort] = useState("date")

  const [loading, setLoading] = useState(true); // State to track loading state

  const [errResponse, setErrResponse] = useState("")


  const [editSyncModelOpen, setEditSyncModelOpen] = useState(false)
  const [toEditSync, setToEditSync] = useState()


  const [pauseSyncModelOpen, setPauseSyncModelOpen] = useState(false)
  const [toPauseSync, setToPauseSync] = useState()
  const [isPause, setIsPause] = useState()
  const [submittingPause, setSubmittingPause] = useState(false)
  const [pauseErrorMessage, setPauseErrorMessage] = useState("")




  const [deleteSyncModelOpen, setDeleteSyncModelOpen] = useState(false)
  const [toDeleteSync, setToDeleteSync] = useState()
  const [submittingDelete, setSubmittingDelete] = useState(false)
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("")



  useEffect(() => {
    const fetchData = async () => {
      try {
        setErrResponse("")
        setLoading(true); // Set loading state to true
        const response = await fetch(config.apiUrl + "/sync/list", {
          headers: {
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
          }
        });

        const status = await response.status;
        if (status === 200) {
          let data = await response.json()
          setSyncs(data)
          setOrderedSyncs(data)
        } else {
          throw new Error('Failed to get syncs');
        }

      } catch (error) {
        setErrResponse("Failed to get syncs. Please try again or contact us.")
        throw error; // Rethrow the error to be caught in the catch block
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Set loading state to false after fetch completes
      }
    };

    fetchData();
  }, []);


  function togglePauseConfirmation() {
    setSubmittingPause(true)
    setPauseErrorMessage("")
    fetch(config.apiUrl + "/sync/" + toPauseSync.id + "/pause", {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
      },
      body: JSON.stringify({ pause: isPause }),
    }).then(response => {
      if (!response.ok) {
        throw new Error('Failed to update sync.');
      }
      return response;
    })
      .then(response => {
        setSubmittingPause(false)
        setToPauseSync(undefined)
        setPauseSyncModelOpen(false)
        setIsPause(undefined)
        window.location.reload()
      })
      .catch(error => {
        setSubmittingPause(false)
        setPauseErrorMessage("Failed to update sync.")
      });


  }

  function deleteSync() {
    setSubmittingDelete(true)
    setDeleteErrorMessage("")
    fetch(config.apiUrl + "/sync/" + toDeleteSync.id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error('Failed to delete sync.');
      }
      return response;
    })
      .then(response => {
        setSubmittingDelete(false)
        setToDeleteSync(undefined)
        setDeleteSyncModelOpen(false)
        window.location.reload()
      })
      .catch(error => {
        setSubmittingDelete(false)
        setDeleteErrorMessage("Failed to delete sync.")
      });
  }

  function getIconsForSyncList(sync) {
    return (
      <div className="flex items-center">

        {getIconForTransfer(sync.transferHistory.sourceAccountType, sync.transferHistory.isSourceYTM)}

        <span className="mx-2">to</span>

        {getIconForTransfer(sync.transferHistory.destinationAccountType, sync.transferHistory.isDestYTM)}

      </div>
    )
  }


  function togglePause(sync, isPause) {
    setPauseErrorMessage("")
    setIsPause(isPause)
    setToPauseSync(sync)
    setPauseSyncModelOpen(true)
  }

  function toggleDeletion(sync) {
    setDeleteErrorMessage("")
    setToDeleteSync(sync)
    setDeleteSyncModelOpen(true)
  }

  function updateOrderedSync() {
    let filteredSyncs = syncs;
    if (filterName.length > 0) {
      filteredSyncs = syncs.filter(sync => sync.name.toLowerCase().includes(filterName.toLowerCase()))
    }

    if(filterSort == "name") {
      filteredSyncs.sort((a, b) => a.name.localeCompare(b.name));
    }

    if(filterSort == "date") {
      filteredSyncs.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }

    if(filterSort == "status") {
      filteredSyncs.sort((a, b) => a.syncStatus.localeCompare(b.syncStatus));
    }

    setOrderedSyncs([...filteredSyncs])
  }

  useEffect(() => {
    updateOrderedSync()
   },[filterName, filterSort])
  
  function SyncList() {
    return (<>

      <ul className="mt-10">
        {orderedSyncs.map((sync, index) => (
          <li key={sync.id}>
            <Divider soft={index > 0} />
            <div className="flex items-center justify-between">
              <div key={sync.id} className="flex gap-6 py-6">
                {/* <div className="w-32 shrink-0">
                  <Link to={"/dashboard/sync/" + sync.id} aria-hidden="true">
                    <img className="aspect-3/2 rounded-lg shadow-sm" src={"https://picsum.photos/300/200?grayscale&id=" + sync.id} alt="" />
                  </Link>
                </div> */}

                <div className="space-y-1.5">
                  <div className="text-base/6 font-semibold text-zinc-950 dark:text-white">
                    <Link to={"/dashboard/sync/" + sync.id}><>{sync.name}</></Link>
                  </div>
                  <div className="text-xs/6 text-zinc-500">
                    Created on {format(parseISO(sync.createdAt), "eeee, MMMM do, yyyy 'at' h:mm a")}
                  </div>
                  <div className="text-xs/6 text-zinc-500">
                    {getIconsForSyncList(sync)}
                  </div>

                </div>

                <div className="space-y-1.5 text-zinc-950 dark:text-white">
                  <div className="text-xs/6">
                    Added {sync.totalToAdd}/{sync.totalAdded} tracks
                  </div>
                  <div className="text-xs/6">
                    Removed {sync.totalToRemove}/{sync.totalRemoved} tracks
                  </div>
                </div>

              </div>
              <div className="flex items-center gap-4">
                {getSyncStatusBadge(sync)}
                <Dropdown>
                  <DropdownButton plain aria-label="More options">
                    <EllipsisVerticalIcon />
                  </DropdownButton>
                  <DropdownMenu anchor="bottom end">
                    <DropdownItem ><Link to={"/dashboard/sync/" + sync.id} >View</Link></DropdownItem>
                    <DropdownItem onClick={() => { setToEditSync(sync); setEditSyncModelOpen(true) }}>Edit</DropdownItem>
                    <DropdownItem onClick={() => togglePause(sync, sync.syncStatus === "PAUSED" ? false : true)} >{sync.syncStatus === "PAUSED" ? "Resume" : "Pause"}</DropdownItem>
                    <DropdownItem onClick={() => toggleDeletion(sync)}>Delete</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </li>
        ))}
      </ul>

      {
        toEditSync === undefined ? (<></>) : (<EditSyncModel sync={toEditSync} editSyncModelOpen={editSyncModelOpen} setEditSyncModelOpen={(flag) => setEditSyncModelOpen(flag)}></EditSyncModel>)
      }
      {/* Pause */}
      {
        toPauseSync === undefined ? (<></>) : (
          <ConfirmationModel
            open={pauseSyncModelOpen}
            setIsOpen={(flag) => { setIsPause(undefined); setToPauseSync(undefined); setPauseErrorMessage(""); setPauseSyncModelOpen(flag) }}
            title={toPauseSync.syncStatus === "PAUSED" ? "Resume " + toPauseSync.name : "Pause " + toPauseSync.name}
            description={toPauseSync.syncStatus === "PAUSED" ? "Do you want to Resume " + toPauseSync.name + " sync?" : "Do you want to Pause " + toPauseSync.name + " sync?"}
            buttonText={toPauseSync.syncStatus === "PAUSED" ? "Resume" : "Pause"}
            submitting={submittingPause}
            confirmationAction={(flag) => { togglePauseConfirmation() }}
            errResponse={pauseErrorMessage}
          ></ConfirmationModel>
        )
      }

      {
        toDeleteSync === undefined ? (<></>) : (
          <ConfirmationModel
            open={deleteSyncModelOpen}
            setIsOpen={(flag) => { setToDeleteSync(undefined); setDeleteSyncModelOpen(flag) }}
            title={"Delete " + toDeleteSync.name}
            description={"Do you want to Delete " + toDeleteSync.name + " sync?"}
            buttonText={"Delete"}
            submitting={submittingDelete}
            confirmationAction={(flag) => { deleteSync() }}
            errResponse={deleteErrorMessage}
          ></ConfirmationModel>
        )
      }

    </>)
  }



  return (
    <>
      {
        loading ? (<><LoadingMain /></>) :
          (syncs.length === 0 ?

            (<div className="flex flex-col justify-center items-center"><Text className="pb-4">{errResponse ? <Field><ErrorMessage>{errResponse}</ErrorMessage></Field> : 'No sync available, transfer a playlist to start sync'}</Text><Link to={config.accountsPath}><Button>Start Transfer</Button></Link></div>)
            : (
              <>
                <div className="flex flex-wrap items-end justify-between gap-4">
                  <div className="max-sm:w-full sm:flex-1">
                    <Heading>Syncs</Heading>
                    <div className="mt-4 flex max-w-xl gap-4">
                      <div className="flex-1">
                        <InputGroup>
                          <MagnifyingGlassIcon />
                          <Input key="sd" name="search" value={filterName} placeholder="Search sync&hellip;" onChange={(e) => {setFilterName(e.target.value)}} />
                        </InputGroup>
                      </div>
                      <div>
                        <Select name="sort_by" onChange={(e) => setFilterSort(e.target.value)}>
                          <option value="date">Sort by date</option>
                          <option value="name">Sort by name</option>
                          <option value="status">Sort by status</option>
                        </Select>
                      </div>
                    </div>
                  </div>
                  <Link to={config.accountsPath}><Button>New Transfer</Button></Link>
                </div>
                <SyncList />
              </>
            )
          )
      }


    </>
  )
}
